import _regeneratorRuntime from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, bugsnagClient;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            bugsnagClient = bugsnag({
              apiKey: '976fae058095028552c9d29c219d43b6',
              appVersion: "".concat(process.env.VERSION, "-").concat(process.env.NODE_ENV, "-").concat(process.env.PLATFORM),
              releaseStage: process.env.NODE_ENV,
              notifyReleaseStages: ['production', 'staging']
            });
            bugsnagClient.use(bugsnagVue, Vue); // bugsnagClient.notify(new Error('Test error'));

            Vue.prototype.$bugsnag = bugsnagClient;

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();